import { ChannelRole } from 'buyplan-common';
import { useSelector } from '../store/reducers';

const useHasChannelRole = (role: ChannelRole): boolean => {
    const { profile, settings } = useSelector(({ user }) => user);
    return profile?.channels.find((chan) => chan.id === settings.activeChannelId)?.channelRole === role;
};

export default useHasChannelRole;
